/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JoinLeaderboardBody
 */
export interface JoinLeaderboardBody {
    /**
     * For WAIVES_FEE competitions, set true to spend a held virtual token to waive the fuel entry fee instead of paying fuel. Ignored for REQUIRED (the token is always the entry method) and fee-only competitions.
     * @type {boolean}
     * @memberof JoinLeaderboardBody
     */
    useToken?: boolean;
}

/**
 * Check if a given object implements the JoinLeaderboardBody interface.
 */
export function instanceOfJoinLeaderboardBody(value: object): value is JoinLeaderboardBody {
    return true;
}

export function JoinLeaderboardBodyFromJSON(json: any): JoinLeaderboardBody {
    return JoinLeaderboardBodyFromJSONTyped(json, false);
}

export function JoinLeaderboardBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinLeaderboardBody {
    if (json == null) {
        return json;
    }
    return {
        
        'useToken': json['useToken'] == null ? undefined : json['useToken'],
    };
}

export function JoinLeaderboardBodyToJSON(json: any): JoinLeaderboardBody {
    return JoinLeaderboardBodyToJSONTyped(json, false);
}

export function JoinLeaderboardBodyToJSONTyped(value?: JoinLeaderboardBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'useToken': value['useToken'],
    };
}

